export default "__VITE_ASSET__yN1lLXPE__"